import React from 'react';
import { Typography } from 'antd';
import { AppstoreAddOutlined } from '@ant-design/icons';
import AssetAccessories from '../AssetAccessories';

const { Title } = Typography;

interface AccessoriesTabProps {
  accessories: any[];
}

const AccessoriesTab: React.FC<AccessoriesTabProps> = ({ accessories }) => {
  return (
    <div style={{ padding: 24 }}>
      <Title level={5} style={{ marginBottom: 16, textTransform: 'uppercase' }}>
        <AppstoreAddOutlined style={{ marginRight: 8 }} />
        Vật tư / Thiết bị
      </Title>
      <AssetAccessories value={accessories} onChange={() => {}} readOnly={true} />
    </div>
  );
};

export default AccessoriesTab; 